import store from '@/store'

export default {
  dashboardGuard: next => {
    store.dispatch('getCurrentSession', 'client').then(session => {
      if (session) {
        store.dispatch('firstFetchPR').then(() => next())
      } else {
        next({ name: 'clientSignIn' })
      }
    })
  },
  prFormGuard: (to, next) => {
    store.dispatch('firstFetchPR').then(() => {
      store.dispatch('fetchPrFormInfos').then(() => {
        let products = store.getters[`${store.$appName}/productRegistrations`]
        let pr = products.find(p => p.id === parseInt(to.params.id))
        if (pr || to.params.id === 'new') {
          next()
        } else {
          next({ name: 'productRegistrations' })
        }
      })
    })
  },
  prReviewGuard: (to, next) => {
    let products = store.getters['bestove/productRegistrations']
    let pr = products.find(p => p.id === parseInt(to.params.id))
    if (pr && pr.no_review) {
      next()
    } else if (pr && !pr.no_review) {
      next({ name: 'productRegistrations',
        params: {
          notification: 'Vous avez déjà soumis un avis pour ce produit.'
        }
      })
    } else {
      next({ name: 'productRegistrations' })
    }
  },
  srFormGuard: (to, next) => {
    store.dispatch('firstFetchPR').then(resp => {
      if (resp) {
        next({ name: 'productRegistrationForm', params: { id: 'new', noProduct: true } })
      }
      if (to.query.id) {
        let products = store.getters['bestove/productRegistrations']
        let product = products.find(p => p.id === parseInt(to.query.id))
        product ? next() : next({ name: 'supportRequests' })
      } else {
        next()
      }
    })
  },
  srReviewGuard: (to, next) => {
    let sr = store.getters['bestove/supportRequests'].find(sr => sr.id === parseInt(to.params.id))
    if (sr && sr.no_review && sr.closed) {
      next()
    } else if (sr && !sr.closed) {
      next({ name: 'supportRequests',
        params: {
          notification: 'La demande d\'assistance est toujours en cours. Vous ne pouvez pas soumettre d\'avis.'
        }
      })
    } else if (sr && !sr.no_review) {
      next({ name: 'supportRequests',
        params: {
          notification: 'Vous avez déjà soumis un avis pour cette demande d\'assistance.'
        }
      })
    } else {
      next({ name: 'supportRequests' })
    }
  }
}
